"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Checkable;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _Functions = require("../core/Functions");

var _utils = require("./utils");

/**
 * Similar to `Controllable`, but specifically for controlling a `checked` property using the same
 * API as native checkbox/radio inputs: `checked`, `defaultChecked`, and `onChange`. Additionally,
 * the events passed to `onChange` use `evt.target.checked` instead of `evt.target.value`.
 *
 * @param {JSX.Component} Component
 * @returns {JSX.Component} A component with defaultable `checked` prop
 */
function Checkable(Component) {
  var CheckableComponent =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(CheckableComponent, _React$Component);

    function CheckableComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, CheckableComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CheckableComponent).call(this, props));
      _this.state = {
        checked: props.defaultChecked
      };
      _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
      _this._refCallback = (0, _utils.makeDecoratorRefCallback)(Component, (0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(CheckableComponent, [{
      key: "handleChange",
      value: function handleChange(evt) {
        var onChange = this.props.onChange;
        this.setState({
          checked: evt.target.checked
        });
        (0, _Functions.callIfPossible)(onChange, evt);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            checked = _this$props.checked,
            __onChange = _this$props.onChange,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["checked", "onChange"]);
        return _react.default.createElement(Component, (0, _extends2.default)({}, rest, {
          checked: checked != null ? checked : this.state.checked,
          onChange: this.handleChange,
          ref: this._refCallback
        }));
      }
    }]);
    return CheckableComponent;
  }(_react.default.Component);

  CheckableComponent.propTypes = (0, _extends2.default)({}, Component.propTypes, {
    checked: _react.PropTypes.bool,
    defaultChecked: _react.PropTypes.bool,
    onChange: _react.PropTypes.func
  });
  CheckableComponent.defaultProps = (0, _extends2.default)({}, Component.defaultProps, {
    defaultChecked: Component.defaultProps && Component.defaultProps.checked != null ? Component.defaultProps.checked : false
  });
  delete CheckableComponent.defaultProps.checked;
  CheckableComponent.displayName = "Checkable(" + (0, _getComponentName.default)(Component) + ")";
  (0, _utils.attachWrappedComponent)(CheckableComponent, Component);
  return CheckableComponent;
}

module.exports = exports.default;